import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "../context/AuthContext";

// pages
import Login from "page/Login";
import ForgotPassword from "page/ForgotPassword";
import Layout from "../components/Layout";
import FrameGlasses from "page/Frame";
import Supplier from "page/Supplier";
import User from "../page/User";
import PrivateRoute from "../components/PrivateRoute";
import MensagemEmail from "page/MensagemEmail";
import Customer from "page/Customer";
import Service from "page/Service";
import Order from "page/Order";
import NewOrder from "page/CreateOrder";
import Lens from "page/Lens";
import StockLab from "page/StockLab";
import StockLensLab from "page/StockLensLab";
import StockLens from "page/Stock-lens";
import Accessory from "page/Accessory";
import Promotion from "page/Promotion";
import ServiceOrder from "page/OS";
import Dashboard from "page/Dashboard";
import Expense from "page/Expense";
import Card from "page/Card";
import CashFlow from "page/CashFlow";

export default function AppRoutes() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/recuperarsenha" element={<ForgotPassword />} />
                    <Route path="/mensagem-sucesso" element={<MensagemEmail />} />

                    <Route
                        element={
                            <PrivateRoute>
                                <Layout />
                            </PrivateRoute>
                        }>
                        <Route path="/armacao" element={<FrameGlasses />} />
                        <Route path="/fornecedor" element={<Supplier />} />
                        <Route path="/usuario" element={<User />} />
                        <Route path="/cliente" element={<Customer />} />
                        <Route path="/servico" element={<Service />} />
                        <Route path="/lente" element={<Lens />} />
                        <Route path="/venda" element={<Order />} />
                        <Route path="/promocao" element={<Promotion />} />
                        <Route path="/novavenda" element={<NewOrder />} />
                        <Route path="/estoque" element={<StockLab />} />
                        <Route path="/estoqueDeLente" element={<StockLens />} />
                        <Route path="/estoqueDeLenteLab" element={<StockLensLab />} />
                        <Route path="/acessorio" element={<Accessory />} />
                        <Route path="/ordem-de-servico" element={<ServiceOrder />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/saida" element={<Expense />} />
                        <Route path="/cartao" element={<Card />} />
                        <Route path="/fluxo-de-caixa" element={<CashFlow />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
